export type FavoritesResourcesType = typeof FavoritesResources;

export const FavoritesResources = {
    title: "Twoje ulubione",
    tab: {
        all: "Wszystkie",
        brands: "Marki",
        shoppingMalls: "Galerie",
        offers: "Okazje",
    },

    brand: {
        title: "Ulubione marki",
        button: "Więcej z marki",
        emptyText: "Nie masz polubionych marek.",
    },

    shoppingMall: {
        title: "Ulubione galerie",
        button: "Więcej z galerie",
        emptyText: "Nie masz polubionych galerii.",
        mapLinkText: "Pokaż na mapie",
    },

    offers: {
        title: "Ulubione okazje",
        button: "Więcej z okazje",
        emptyText: "Nie masz polubionych okazji.",
    },
};
